import { render } from "./GiftsPage.vue?vue&type=template&id=739e5f82&scoped=true"
import script from "./GiftsPage.vue?vue&type=script&lang=js"
export * from "./GiftsPage.vue?vue&type=script&lang=js"

import "./GiftsPage.vue?vue&type=style&index=0&id=739e5f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739e5f82"]])

export default __exports__